import React from 'react';
import Button from './Button';

/**
 * EmptyState — пустое состояние с иконкой, заголовком, подсказкой и CTA.
 *
 * @param {React.ReactNode} icon — иконка или эмодзи
 * @param {string} title
 * @param {string} hint
 * @param {string} actionLabel — текст кнопки
 * @param {function} onAction — обработчик кнопки
 */
const EmptyState = ({ icon, title, hint, actionLabel, onAction }) => (
  <div className="bm-empty bm-animate-in">
    {icon && <div className="bm-empty__icon">{icon}</div>}
    {title && <p className="bm-empty__title">{title}</p>}
    {hint && <p className="bm-empty__hint">{hint}</p>}
    {actionLabel && onAction && (
      <Button variant="primary" size="md" onClick={onAction}>
        {actionLabel}
      </Button>
    )}
  </div>
);

export default EmptyState;
